var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql } from '@apollo/client';
export default gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment TICKET_FLAG_FRAGMENT on TicketFlag {\n    id\n    active\n    display_name\n  }\n"], ["\n  fragment TICKET_FLAG_FRAGMENT on TicketFlag {\n    id\n    active\n    display_name\n  }\n"])));
var templateObject_1;
